import { handleActions } from "redux-actions";
import {
  FETCH_CHART_SUCCESS,
  FETCH_CURRENT_USER_SUCCESS,
  RESET_FILTER_SELECTED,
  SET_DATES,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  SET_UPDATES_LOADING,
  UPDATE_DATES,
  UPDATE_PERIOD_DAYS,
  UPDATE_CUSTOM_RANGE,
  UPDATE_TABLE_VIEW_SELECTED,
  FETCH_FILTERS_SUCCESS,
  UPDATE_FILTERS
} from "./noVisitAfterFirstVisitSagas";

import {
  getDateRanges,
  getMonthlyRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";

export const initialState = {
  currentUser: {},
  initialRequest: false,
  chartData: {},
  filters: [],
  isLoading: true,
  updatesLoading: false,
  filtersDirty: false,
  selectedRequestDates: {},
  selectedFilters: {
    table_view: false,
    period_days: "60 days",
    category: []
  },
  selectedRangeOption: {},
  rangeOptions: [],
  timeOptions: ["30 days", "60 days"]
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_DATES]: (state, action) => {
      let rangeOptions = getMonthlyRangeOptions(
        state.currentUser.calendarEndDate,
        state.currentUser.theBeginningOfTime
      );

      return {
        ...state,
        selectedRequestDates: action.payload,
        rangeOptions: [...rangeOptions, getSelectedRangeOptionWithCustom(action)],
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      filtersDirty: true,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      selectedFilters: {
        ...state.selectedFilters
      }
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: {
        ...state.selectedFilters,
        period_days: "60 days",
        table_view: false
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload
    }),
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.theBeginningOfTime
      ),
      filtersDirty: true
    }),
    [UPDATE_PERIOD_DAYS]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        period_days: action.payload
      }
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => {
      let filters = Object.entries(action.payload).map((el) => {
        return { name: el[1], id: el[0] };
      });
      return {
        ...state,
        filters: filters,
        selectedFilters: {
          ...state.selectedFilters,
          category: filters
        }
      };
    },
    [UPDATE_FILTERS]: (state, action) => {
      return {
        ...state,
        filtersDirty: true,
        selectedFilters: {
          ...state.selectedFilters,
          category: action.payload
        }
      };
    }
  },
  initialState
);
